<template>
  <!-- ✅ JANGAN v-if isAdmin DI ROOT -->
  <div class="admin-root">
    <!-- Topbar -->
    <nav class="navbar navbar-light bg-white border-bottom sticky-top">
      <div class="container-fluid">
        <!-- toggle mobile -->
        <button
          class="btn btn-outline-secondary d-lg-none"
          @click="showMobileNav = true"
        >
          <i class="bx bx-menu"></i>
        </button>

        <!-- Brand -->
        <div class="d-flex align-items-center gap-2">
          <i class="bx bx-receipt fs-5 text-secondary"></i>
          <span class="fw-semibold">Imah Kopi ERP Lite</span>
        </div>

        <!-- USER DROPDOWN -->
        <div class="dropdown">
          <button
            class="btn btn-light d-flex align-items-center gap-2 dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span class="text-muted small d-none d-sm-inline">
              {{ currentUser?.username || "User" }}
            </span>
            <i class="bx bx-user-circle fs-4 text-secondary"></i>
          </button>

          <!-- Dropdown Menu -->
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <button class="dropdown-item text-danger" @click="logout">
                <i class="bx bx-log-out me-2"></i> Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Sidebar -->
    <aside
      class="sidebar bg-white border-end"
      :class="{ 'is-open': showMobileNav }"
    >
      <!-- mobile header -->
      <div
        class="d-flex d-lg-none align-items-center justify-content-between px-3 py-3 border-bottom"
      >
        <strong>Menu</strong>
        <button class="btn-close" @click="showMobileNav = false"></button>
      </div>

      <div class="sidebar-inner">
        <!-- logo -->
        <div class="px-3 py-3 border-bottom d-none d-lg-block">
          <img
            src="../../assets/img/logo/Logo.png"
            alt="logo"
            style="max-width: 100px"
          />
        </div>

        <!-- MENU -->
        <ul class="nav flex-column py-2">
          <!-- Dashboard -->
          <li class="nav-item">
            <RouterLink
              :to="{ name: 'Dashboard' }"
              class="nav-link sidebar-link"
              :class="{ active: $route.name === 'Dashboard' }"
            >
              <i class="bx bx-grid-alt me-2"></i> Dashboard
            </RouterLink>
          </li>

          <!-- ✅ MASTER DATA ADMIN ONLY -->
          <li class="nav-item">
            <button
              class="nav-link sidebar-link w-100 text-start d-flex justify-content-between align-items-center"
              @click="showMasterMenu = !showMasterMenu"
            >
              <span>
                <i class="bx bx-folder me-2"></i>
                Master Data
              </span>

              <i
                class="bx"
                :class="showMasterMenu ? 'bx-chevron-up' : 'bx-chevron-down'"
              ></i>
            </button>

            <!-- Submenu -->
            <ul v-if="showMasterMenu" class="submenu">
              <li>
                <RouterLink
                  :to="{ name: 'Customers' }"
                  class="nav-link sidebar-sublink"
                >
                  👤 Customers
                </RouterLink>
              </li>

              <li v-if="isAdmin">
                <RouterLink
                  :to="{ name: 'Products' }"
                  class="nav-link sidebar-sublink"
                >
                  📦 Products
                </RouterLink>
              </li>

              <li>
                <RouterLink
                  :to="{ name: 'DeliveryMethods' }"
                  class="nav-link sidebar-sublink"
                >
                  🚚 Delivery
                </RouterLink>
              </li>

              <li>
                <RouterLink
                  :to="{ name: 'Polls' }"
                  class="nav-link sidebar-sublink"
                >
                  🗳 Pools
                </RouterLink>
              </li>
            </ul>
          </li>

          <!-- Invoice -->
          <li class="nav-item">
            <RouterLink
              :to="{ name: 'Invoice' }"
              class="nav-link sidebar-link"
              :class="{ active: $route.name === 'Invoice' }"
            >
              <i class="bx bx-file me-2"></i> Invoice
            </RouterLink>
          </li>

          <!-- Transaction -->
          <li class="nav-item">
            <RouterLink
              :to="{ name: 'Transaksi' }"
              class="nav-link sidebar-link"
              :class="{ active: $route.name === 'Transaksi' }"
            >
              <i class="bx bx-list-ul me-2"></i> Transaction
            </RouterLink>
          </li>

          <!-- Delivery Note -->
          <li class="nav-item">
            <RouterLink
              :to="{ name: 'OrdersList' }"
              class="nav-link sidebar-link"
              :class="{ active: $route.name === 'OrdersList' }"
            >
              <i class="bx bx-list-ul me-2"></i> Delivery Note
            </RouterLink>
          </li>

          <!-- Production -->
          <li class="nav-item">
            <RouterLink
              :to="{ name: 'ProductionList' }"
              class="nav-link sidebar-link"
              :class="{ active: $route.name === 'ProductionList' }"
            >
              <i class="bx bx-bowl-hot me-2"></i> Daily Production Plan
            </RouterLink>
          </li>
        </ul>
      </div>
    </aside>

    <!-- backdrop mobile -->
    <div
      v-if="showMobileNav"
      class="backdrop d-lg-none"
      @click="showMobileNav = false"
    ></div>

    <!-- Main -->
    <main class="admin-main">
      <div class="container-xxl py-4">
        <RouterView />
      </div>
    </main>
  </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "AdminLayout",
  setup() {
    const showMobileNav = ref(false);
    const showMasterMenu = ref(false);

    const route = useRoute();
    const router = useRouter();

    // ============================
    // CURRENT USER
    // ============================
    const currentUser = computed(() => {
      try {
        return JSON.parse(localStorage.getItem("user") || "null");
      } catch {
        return null;
      }
    });

    // ============================
    // ADMIN CHECK
    // ============================
    const isAdmin = computed(() => {
      return currentUser.value && Number(currentUser.value.role) === 0;
    });

    // ============================
    // LOGOUT
    // ============================
    const logout = () => {
      localStorage.removeItem("loggedIn");
      localStorage.removeItem("user");
      router.push("/");
    };

    // ============================
    // AUTO CLOSE MOBILE NAV
    // ============================
    watch(() => route.fullPath, () => {
      showMobileNav.value = false;
    });

    return {
      showMobileNav,
      showMasterMenu,
      currentUser,
      isAdmin,
      logout,
    };
  },
};
</script>

<style scoped>
.admin-root {
  min-height: 100vh;
  background: #f8f9fa;
}

/* sidebar */
.sidebar {
  width: 260px;
  position: fixed;
  top: 56px;
  bottom: 0;
  left: 0;
  z-index: 1030;
  transform: translateX(-100%);
  transition: transform 0.2s ease;
}
.sidebar.is-open {
  transform: translateX(0);
}

/* desktop */
@media (min-width: 992px) {
  .sidebar {
    transform: none;
  }
  .admin-main {
    margin-left: 260px;
    padding-top: 16px;
  }
}

/* links */
.sidebar-inner .nav-link {
  padding: 10px 16px;
  color: #495057;
  border-left: 3px solid transparent;
}
.sidebar-inner .nav-link:hover {
  background: #f1f3f5;
}
.sidebar-inner .nav-link.active {
  background: #eef2ff;
  color: #1f3eff;
  border-left-color: #1f3eff;
  font-weight: 600;
}

/* submenu */
.submenu {
  list-style: none;
  padding-left: 18px;
  margin: 6px 0 10px;
}
.sidebar-sublink {
  padding: 8px 16px;
  font-size: 13px;
}

/* backdrop */
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 1025;
}
</style>
